var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"segmented-trends-date-label"},[_vm._v(_vm._s(_vm.$t("dataTimeSpan"))+" : "+_vm._s(_vm.dateLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }